import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(function () {
    if ($('body').is('#projects-questionnaires')) {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('modal') === 'send') {
        setTimeout(() => {
          const questionnaireID = urlParams.get('project_questionnaire_id');
          const $requestButton = $(
            `.h-s-button--request-questionnaire[data-project-questionnaire-id="${questionnaireID}"]`
          );

          if ($requestButton.length) {
            const $accordion = $requestButton.closest('.df-accordion');

            if (!$accordion.hasClass('df-accordion--open')) {
              $accordion.find('.df-accordion__header').click();
              setTimeout(() => {
                $requestButton.click();
              }, 0);
            } else {
              $requestButton.click();
            }
          }
        }, 0);
      }
    }
  });
});
